import { render, staticRenderFns } from "./BrandFields.vue?vue&type=template&id=27cf3639&scoped=true&"
import script from "./BrandFields.vue?vue&type=script&lang=js&"
export * from "./BrandFields.vue?vue&type=script&lang=js&"
import style0 from "./BrandFields.vue?vue&type=style&index=0&id=27cf3639&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27cf3639",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRadio,VRadioGroup,VRow})
